import e from"react";import t from"../../../../RichTextRenderer/RichTextRenderer.js";import{Container as r}from"./styles.js";const m=({value:m=""})=>e.createElement(r,null,e.createElement(t,{text:m}));export{m as Description};
//# sourceMappingURL=Description.js.map
